var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_751)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#C06198"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_36_751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1257 7.14282C10.7056 6.7623 9.24026 7.60831 8.85974 9.02844L4.10514 26.7728C3.72462 28.193 4.57063 29.6583 5.99076 30.0388L19.156 33.5664C20.5761 33.947 22.0414 33.101 22.422 31.6808L25.4128 20.519L18.8301 18.7552C17.41 18.3747 16.564 16.9094 16.9445 15.4892L18.7083 8.90662L12.1257 7.14282ZM20.2907 9.86983L18.6617 15.9493C18.5349 16.4227 18.8169 16.9112 19.2903 17.038L25.3698 18.667L20.2907 9.86983ZM11.7669 19.9301L19.2081 21.924C19.682 22.051 19.9636 22.5387 19.8366 23.0126C19.7096 23.4866 19.2219 23.7682 18.748 23.6412L11.3067 21.6473C10.8328 21.5203 10.5512 21.0326 10.6782 20.5586C10.8052 20.0847 11.2929 19.8031 11.7669 19.9301ZM10.6877 23.9354L15.837 25.3152C16.311 25.4422 16.5927 25.9293 16.4656 26.4038C16.3497 26.8384 15.9306 27.1116 15.4964 27.056L15.378 27.0327L10.2287 25.6529C9.75471 25.5259 9.47312 25.0382 9.60012 24.5642C9.71653 24.1298 10.1351 23.8565 10.5693 23.9121L10.6877 23.9354Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_36_751",
    x: -11.986,
    y: -0.948322,
    width: 53.3987,
    height: 58.6059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.482353 0 0 0 0 0.8 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_36_751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_36_751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.5e8db0808c68331590795fe5daf9392e.svg";
export { ForwardRef as ReactComponent };